import { DATA_SOURCE_IDS } from '@discover-frontend/constants';
import {
  Button,
  ButtonIcon,
  Col,
  ListGroup,
  Row,
  Tooltip,
} from '@cubeyou-team/hx-react-components';
import theme from '@cubeyou-team/hx-theme';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isAvailableAddon } from 'src/utils/AuthHelperMethods';
import {
  addApplicationTab,
  addItemToCompare,
  collapseRepository,
  removeItemToCompare,
  sendEvent,
} from '../../../actions';
import { APPS_MAP } from '../../../constants/config';
import RepositoryItemMoreActions from '../../RepositoryItemActions/components/RepositoryItemMoreActions';
import { StyledItemActions } from '../RepositoryItemExtended.styles';

const ExtendedItemActions = ({ item, actions }) => {
  const [isMoreActionsOpen, setIsMoreActionsOpen] = useState(false);
  const dispatch = useDispatch();
  const audiencesToCompare = useSelector(
    state => state.repository.audiencesToCompare
  );
  const isCompared = audiencesToCompare.some(
    audience => audience.id === item.id
  );
  const { persistence, metadata, type } = item;

  const isTemporary = persistence === 'temporary';
  const isReady = metadata?.status === 'ready';

  const buttonsList = useMemo(
    () => [
      {
        label: 'analyze',
        condition: true,
        onClick: () => {
          dispatch(collapseRepository());
          dispatch(addApplicationTab(item, APPS_MAP.ANALYZE));
        },
      },
      {
        label: 'segment',
        condition:
          metadata?.data_source === DATA_SOURCE_IDS.TWITTER &&
          isAvailableAddon(APPS_MAP.SEGMENTATION),
        onClick: () => {
          dispatch(collapseRepository());
          dispatch(addApplicationTab(item, APPS_MAP.SEGMENTATION));
        },
      },
      {
        label: 'compare',
        condition:
          metadata?.audience_type !== 'tsv' &&
          metadata?.data_source === DATA_SOURCE_IDS.TWITTER &&
          isAvailableAddon(APPS_MAP.COMPARE),
        onClick: () =>
          !isCompared
            ? dispatch(addItemToCompare(item))
            : dispatch(removeItemToCompare(item.id)),
      },
    ],
    [metadata, dispatch, item, isCompared]
  );

  const audienceActions = useMemo(() => {
    return buttonsList.map(button => {
      if (!button.condition) return null;

      return (
        <Button
          size="small"
          variant="outlined"
          key={button.label}
          onClick={button.onClick}
        >
          {button.label}
        </Button>
      );
    });
  }, [buttonsList]);

  if (type === 'folder') {
    return (
      <StyledItemActions>
        <Row gutter="none">
          <Col span="auto">
            <RepositoryItemMoreActions
              item={item}
              show={isMoreActionsOpen}
              onMoreActionClick={setIsMoreActionsOpen}
              actions={actions}
            />
          </Col>
        </Row>
      </StyledItemActions>
    );
  }
  return (
    <StyledItemActions>
      <Row valign="middle" gutter="none">
        <Col span="auto">
          <ListGroup
            className="audience-actions"
            direction="row"
            items={audienceActions}
          />
        </Col>
        {isReady && (
          <Col>
            <Tooltip content="Save" position="top">
              <ButtonIcon
                size="small"
                data-test="save-button"
                data-test-is-permanent={!isTemporary}
                icon={isTemporary ? 'star_outline' : 'star'}
                variant={!isTemporary ? 'warning' : 'dark'}
                onClick={e => {
                  e.stopPropagation();
                  actions.save(item);
                  dispatch(sendEvent('Workspace'));
                }}
                disabled={!isReady || !isTemporary}
                customDisabledColor={theme.colors.warning}
              />
            </Tooltip>
          </Col>
        )}
        <Col span="auto">
          <RepositoryItemMoreActions
            item={item}
            show={isMoreActionsOpen}
            onMoreActionClick={setIsMoreActionsOpen}
            actions={actions}
          />
        </Col>
      </Row>
    </StyledItemActions>
  );
};

export default ExtendedItemActions;
